// extracted by mini-css-extract-plugin
export var highlightFade = "_2n-4";
export var highlighted = "_2n-3";
export var table = "_2n-1";
export var tableContainer = "_2n-0";
export var totalsRow = "_2n-2";